export enum Lang {
  EN = 'en',
  FR = 'fr'
};

export const LANGUAGES: Lang[] = [Lang.EN, Lang.FR];
